import { Box, Text, Tooltip } from "@govlaunch/web";
import React from "react";
import { ICardViewMode } from "~/src/components/collection/cardViewMode";
import { containsWordLongerThan } from "~/src/components/collection/bundleCard/utils/cardNameUtils";

interface IBundleCollectionCardNameProps {
  viewMode: ICardViewMode;
  color?: string;
  name: string;
}

export default function BundleCollectionCardName({ viewMode, color = "white", name }: IBundleCollectionCardNameProps) {
  return (
    <Box
      display="flex"
      minHeight={viewMode === ICardViewMode.Bundles ? "136px" : "116px"}
      alignItems="center"
      justifyContent="center"
    >
      {name.length > 50 && (
        <Tooltip bg="gray.400" label={name} borderRadius={10}>
          <Text
            color={color || "white"}
            textAlign="center"
            fontSize={["2xl", "xl", "xl", viewMode === ICardViewMode.Bundles ? "2xl" : "xl"]}
            fontWeight="bold"
            wordBreak={containsWordLongerThan(name, 17) ? "break-all" : "normal"}
            clamp={3}
          >
            {name}
          </Text>
        </Tooltip>
      )}
      {name.length <= 50 && (
        <Text
          color={color || "white"}
          textAlign="center"
          fontSize={["2xl", "xl", "xl", viewMode === ICardViewMode.Bundles ? "2xl" : "xl"]}
          fontWeight="bold"
          wordBreak={containsWordLongerThan(name, 17) ? "break-all" : "normal"}
          clamp={3}
        >
          {name}
        </Text>
      )}
    </Box>
  );
}
